<template>
  <div class="input-box">
    <div class="is-14m">{{ title }}</div>
    <input type="text" class="is-14r" :placeholder="placeholder" @input="inputData($event)" />
  </div>
</template>

<script>
export default {
  name: 'EmailInputForm',
  props: {
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    inputData(e) {
      const data = e.target.value
      this.$emit('inputData', this.type, data)
    }
  }
}
</script>

<style scoped lang="scss">
.input-box {
  display: flex;
  border: 1px solid #dbdbdb;
  border-bottom: 0;

  .is-14m {
    width: 100px;
    padding: 14px;
    background: #fbfbfb;
    border-right: 1px solid #dbdbdb;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .is-14r {
    width: 634px;
    padding: 16px;
    &::placeholder {
      color: #909090;
      font-family: Pretendard;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }
  }
}
</style>
